import { website_name } from '../config/app-config';
import { getAppId } from '../config/config';
import { CookieStorage, isStorageSupported } from '../storage/storage';

export const isBotblitzDomain = (): boolean =>
    typeof window !== 'undefined' && !!window.location.hostname && window.location.hostname.endsWith('botblitz.site');

export const redirectToLogin = (is_logged_in: boolean, language: string, has_params = true, redirect_delay = 0) => {
    if (!is_logged_in && isStorageSupported(sessionStorage)) {
        const l = window.location;
        const redirect_url = has_params ? window.location.href : `${l.protocol}//${l.host}${l.pathname}`;
        sessionStorage.setItem('redirect_url', redirect_url);
        setTimeout(() => {
            window.location.href = loginUrl({ language });
        }, redirect_delay);
    }
};

// Same as root: single signup URL (track.deriv.com)
const ROOT_SIGNUP_URL = 'https://track.deriv.com/_5b97G5QPtjsKqFKZ7JdnQ2Nd7ZgqdRLk/1/';

export const redirectToSignUp = (_options?: { is_appstore?: boolean }) => {
    window.location.href = ROOT_SIGNUP_URL;
};

type TLoginUrl = {
    language: string;
};

// Same as root: always oauth.deriv.com with app_id from getAppId (env / localStorage)
export const loginUrl = ({ language }: TLoginUrl) => {
    const app_id = getAppId();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const signup_device_cookie = new (CookieStorage as any)('signup_device');
    const signup_device = signup_device_cookie.get('signup_device');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const date_first_contact_cookie = new (CookieStorage as any)('date_first_contact');
    const date_first_contact = date_first_contact_cookie.get('date_first_contact');
    const marketing_queries = `${signup_device ? `&signup_device=${signup_device}` : ''}${
        date_first_contact ? `&date_first_contact=${date_first_contact}` : ''
    }`;
    return `https://oauth.deriv.com/oauth2/authorize?app_id=${app_id}&l=${language}${marketing_queries}&brand=${website_name.toLowerCase()}`;
};
